import { baseTheme, Theme, UserTheme } from "styles/theme"

import getColors from "./getColors"
import getPalette from "./getPalette"

const getTheme = (userTheme: UserTheme): Theme => {
  // Palette
  const palette = getPalette(userTheme)

  // Colors
  const colors = getColors()

  return {
    ...baseTheme,
    ...userTheme,
    colors,
    font: {
      ...baseTheme.font,
      ...userTheme.font
    },
    palette
  }
}

export default getTheme
